import dayjs from 'dayjs'
import { Trans } from '@lingui/react/macro'

import { useBrandName } from '@jotta/grpc-connect-client/config'
import type { GetPaymentInfoResponse } from '@jotta/grpc-connect-openapi/payment'
import { FormattedContent } from '@jotta/ui/FormattedContent'

export interface SubscriptionRenewalInfoProps {
  subscription: GetPaymentInfoResponse
}

export const SubscriptionExpirationInfo: React.FC<
  SubscriptionRenewalInfoProps
> = ({ subscription: { expirationDateMillis, changeSubscriptionOption } }) => {
  const brandName = useBrandName()

  if (expirationDateMillis) {
    const expirationDate = dayjs(expirationDateMillis.value).format('L')

    switch (changeSubscriptionOption.case) {
      case 'normalUpgrade':
        return (
          <FormattedContent>
            <p>
              <Trans>
                Your subscription expires {expirationDate}.{' '}
                <a href="/web/expire" className="link">
                  Register a credit card
                </a>{' '}
                to convert to a recurring subscription that automatically renews
                at the expire date.
              </Trans>
            </p>
          </FormattedContent>
        )

      case 'saSubscription':
        return (
          <FormattedContent>
            <p>
              <Trans>
                Your subscription is a part of your support agreement with{' '}
                {brandName}. Your subscription expires {expirationDate}.{' '}
                <a href="/web/renew" className="link">
                  Register a credit card
                </a>{' '}
                to convert to a recurring subscription that automatically renews
                at the expire date.
              </Trans>
            </p>
          </FormattedContent>
        )
      default:
        return (
          <FormattedContent>
            <p>
              <Trans>Your subscription expires {expirationDate}.</Trans>
            </p>
          </FormattedContent>
        )
    }
  } else {
    return null
  }
}
